import { http } from "../plugin/http2-common";

class LensSliderService {
  listProfiles(surveyId) {
    return http.get("/profile/list/" + surveyId);
  }
  saveProfile(data) {
    return http.put("/profile/update", data);
  }
}

export default new LensSliderService();
